import axios from 'axios';

export default function validateAndRepriceConfigurations(data) {
  const url = `${window.location.origin}/api/estimates/validateAndRepriceConfigurations`;

  return axios.post(url, data);
}
